import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelL } from '@sorare/core/src/atoms/typography';
import { Dialog } from '@sorare/core/src/components/dialog';

import { GemsPack } from '../BuyPacks/GemsPack';
import type { BuyGemsDialog_inGameCurrencyPack } from './__generated__/index.graphql';

const DialogBody = styled(Vertical)`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: var(--double-unit);
  padding: 0 var(--triple-unit) var(--triple-unit) var(--triple-unit);
`;
const GemsPackContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, calc(50% - var(--unit)));
  gap: var(--double-unit);
  min-width: min(400px, calc(var(--100vw) - 6 * var(--unit)));
`;

type Props = {
  open: boolean;
  onClose: () => void;
  gemsPacks: Nullable<BuyGemsDialog_inGameCurrencyPack[]>;
};

export const BuyGemsDialog = ({ open, onClose, gemsPacks }: Props) => {
  return (
    <Dialog
      open={open}
      title={
        <Horizontal center>
          <LabelL bold>
            <FormattedMessage id="GemsPacks.title" defaultMessage="Buy Gems" />
          </LabelL>
        </Horizontal>
      }
      onClose={onClose}
    >
      <DialogBody>
        <GemsPackContainer>
          {Array.from(gemsPacks || [])
            .sort((a, b) => a.baseAmount - b.baseAmount)
            .map(gemsPack => (
              <GemsPack
                key={gemsPack.id}
                gemsPack={gemsPack}
                onClose={onClose}
              />
            ))}
        </GemsPackContainer>
      </DialogBody>
    </Dialog>
  );
};

BuyGemsDialog.fragments = {
  inGameCurrencyPack: gql`
    fragment BuyGemsDialog_inGameCurrencyPack on InGameCurrencyPack {
      id
      ...GemsPack_inGameCurrencyPack
    }
    ${GemsPack.fragments.inGameCurrencyPack}
  ` as TypedDocumentNode<BuyGemsDialog_inGameCurrencyPack>,
};
